import { render, staticRenderFns } from "./DashboardReadOnly.vue?vue&type=template&id=394712e9"
import script from "./DashboardReadOnly.vue?vue&type=script&lang=ts"
export * from "./DashboardReadOnly.vue?vue&type=script&lang=ts"
import style0 from "./DashboardReadOnly.vue?vue&type=style&index=0&id=394712e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports